import React from 'react';
import classNames from 'classnames';

import { Button } from '@/components/generic/Button';
import { IconArrowRightV2 } from '@/components/icons/IconArrowRightV2';
import { IconDownloadV2 } from '@/components/icons/IconDownloadV2';
import { useOrderContext } from '@/components/modals/SubmitOrder/helpers';

import { MATERIALS_FILE_PATH } from '../../constants';

import { Props } from './types';

import styles from '../../SuccessStep.module.scss';

export const WhatsNext = ({ isTimberline, navitageTo }: Props) => {
  const state = useOrderContext();
  const isActivityDistributionModel = state.isDistribution;
  const isAccessDistributionModel = state.isAccessProgram && state.isDistribution;

  const materialListFilePath = isTimberline
    ? MATERIALS_FILE_PATH.TIMBERLINE
    : MATERIALS_FILE_PATH.DECOTECH;

  return (
    <>
      {isActivityDistributionModel ? (
        <br />
      ) : (
        <a
          className={styles.download_link}
          href={materialListFilePath}
          rel="noreferrer"
          target="_blank"
        >
          <IconDownloadV2 className={styles.download_icon} />
          Download materials list
        </a>
      )}
      <div className={styles.whats_next_block}>
        <span className={styles.whats_next_title}>What’s next?</span>
        {isAccessDistributionModel && (
          <ul className={styles.whats_next_list}>
            <li>The contract will be sent to the homeowner</li>
            <li>The final bill of materials will be shared with you</li>
          </ul>
        )}
        <Button
          className={classNames(
            styles.whats_next_button,
            isActivityDistributionModel && styles.whats_next_button_onlyText,
          )}
          data-testid="whats-next-button"
          onClick={navitageTo}
        >
          {isActivityDistributionModel ? (
            <span>UPLOAD Project documents</span>
          ) : (
            <>
              <span>Upload Additional Order Documents</span>
              <IconArrowRightV2 />
            </>
          )}
        </Button>
      </div>
    </>
  );
};
